import { FunctionComponent } from 'react';
import { ConfigPageLayout } from '@cbridge-modules/layout';
import { UserSettingsPage } from '@cbridge-packages/user-settings';
import { FiltersPanel } from '@cbridge-tools/filters-panel';
import { SymbolGroupsSubscriber } from '@cbridge-packages/symbol-groups';
import { CoreSymbolGroupsFilter } from '@cbridge-modules/symbol-groups-filter';
import { SymbolsNavigation } from '../../_navigation/SymbolsNavigation';

export const SymbolsCoreLayout: FunctionComponent = () => {
  return (
    <>
      <SymbolGroupsSubscriber />

      <ConfigPageLayout settingsKey={UserSettingsPage.ConfigSymbolsCore}>
        <SymbolsNavigation />
        <FiltersPanel>
          <CoreSymbolGroupsFilter />
        </FiltersPanel>
      </ConfigPageLayout>
    </>
  );
};
